var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.61361 6.984L8.95222 8.14519L9.25855 6.47302L4.88605 5.672L6.3786 1.48481L4.77729 0.914012L2.61361 6.984Z","fill":"#191C22","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.14999 10.322L1.14999 11.172C1.14999 15.5075 4.66456 19.022 8.99999 19.022C13.3354 19.022 16.85 15.5075 16.85 11.172C16.85 6.83659 13.3354 3.32202 8.99999 3.32202C7.28584 3.32202 5.69773 3.87243 4.40606 4.80599L3.71716 5.3039L4.71298 6.6817L5.40188 6.1838C6.41343 5.45269 7.65517 5.02202 8.99999 5.02202C12.3965 5.02202 15.15 7.77547 15.15 11.172C15.15 14.5686 12.3965 17.322 8.99999 17.322C5.60344 17.322 2.84999 14.5686 2.84999 11.172L2.84999 10.322L1.14999 10.322Z","fill":"#191C22","key":1})]);
}

Refresh.defaultProps = {"width":"17","height":"20","viewBox":"0 0 17 20","fill":"none"};

module.exports = Refresh;

Refresh.default = Refresh;
